import { TriasRequest } from '@/modules/TriasRequest';
import { IndividualTripParamStructure, RoutingAPI } from '@/modules/api-routing';
import type { RouteLocationFeature } from '@/types/RouteLocationFeature';
import type { RoutesState } from '@/types/RoutesState';
import type { Trias } from '@/types/Trias';

export class Routing {
  public static async get(parameters: {
    origin: RouteLocationFeature;
    destination: RouteLocationFeature;
    time: RoutesState['time'];
  }): Promise<Trias> {
    const triasRequest = TriasRequest.make({
      ...parameters,
      algorithm: IndividualTripParamStructure.algorithmType.BEAUTIFUL,
    });

    const [beautiful, optimal, fastest] = await Promise.all([
      RoutingAPI.getIndividualRoutes({ triasRequest }),
      RoutingAPI.getIndividualRoutes({
        triasRequest: TriasRequest.make({
          ...parameters,
          algorithm: IndividualTripParamStructure.algorithmType.OPTIMAL,
        }),
      }),
      RoutingAPI.getIndividualRoutes({
        triasRequest: TriasRequest.make({
          ...parameters,
          algorithm: IndividualTripParamStructure.algorithmType.FASTEST,
        }),
      }),
    ]);

    return {
      triasRequest,
      ...beautiful,
      serviceDelivery: {
        ...beautiful.serviceDelivery,
        deliveryPayload: {
          individualRouteResponse: {
            errorMessage: [
              ...(beautiful.serviceDelivery?.deliveryPayload?.individualRouteResponse?.errorMessage ?? []),
              ...(optimal.serviceDelivery?.deliveryPayload?.individualRouteResponse?.errorMessage ?? []),
              ...(fastest.serviceDelivery?.deliveryPayload?.individualRouteResponse?.errorMessage ?? []),
            ],
            routeResult: [
              ...(beautiful.serviceDelivery?.deliveryPayload?.individualRouteResponse?.routeResult ?? []),
              ...(optimal.serviceDelivery?.deliveryPayload?.individualRouteResponse?.routeResult ?? []),
              ...(fastest.serviceDelivery?.deliveryPayload?.individualRouteResponse?.routeResult ?? []),
            ],
            individualRouteResponseContext: {
              situations: {
                roadSituation: [
                  ...(beautiful.serviceDelivery?.deliveryPayload?.individualRouteResponse
                    ?.individualRouteResponseContext?.situations?.roadSituation ?? []),
                  ...(optimal.serviceDelivery?.deliveryPayload?.individualRouteResponse?.individualRouteResponseContext
                    ?.situations?.roadSituation ?? []),
                  ...(fastest.serviceDelivery?.deliveryPayload?.individualRouteResponse?.individualRouteResponseContext
                    ?.situations?.roadSituation ?? []),
                ],
              },
            },
          },
        },
      },
    };
  }
}
